export const FILES_DOWNLOAD_BOOK = {
  BOOK: "info.json",
  TOC: "toc.json",

  TRACKS: "tracks.json", // isn't used
  PARAS: "para.json", // isn't used
};

export const makeBooksDownloadCancelTokenKey = (bookIdOrigin) => {
  return "books/download/" + bookIdOrigin;
};

export const makeAudioDownloadCancelTokenKey = (bookId) => {
  return "audio/download/" + bookId;
};
